import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["input", "icon"];

    toggle() {
        const isPassword = this.inputTarget.type === "password";

        // Switch input type
        this.inputTarget.type = isPassword ? "text" : "password";

        // Toggle the icon class
        this.iconTarget.classList.toggle("bi-eye", !isPassword);
        this.iconTarget.classList.toggle("bi-eye-slash", isPassword);
    }
}